'use strict';
const angular = require('angular');

export class referralFormComponent {
  /*@ngInject*/
  constructor(ReferralService, dialogs, User, Auth) {
    this.Auth = Auth;
    this.ReferralService = ReferralService;
    this.dialogs = dialogs;

    this.user = this.Auth.getCurrentUserSync();

    this.referral = {
      for: -1,
      meta: {}
    };

    User.query(data => {
      this.recipients = data.filter(user => user.active && user.role.includes("member")).map(user => {
        user.fullName = user.firstName + ' ' + user.lastName + ' - ' + user.companyName;
        user.group = "Members";
        return user;
      });

      this.recipients.unshift({group: "Group", fullName: "Best of the Best Network"});

      if (this.user && this.user._id) {
        this.referral.meta.creationUser = this.user._id;
        this.recipients = this.recipients.filter(user => user._id != this.user._id);
      }
    });
  }

  submit() {
    this.ReferralService.save(this.referral, () => {
      this.dialogs.notify("Your referral has been sent","Your referral has been sent.<br/>Thank you!");
      this.dismiss();
    });
  }
}

export default angular.module('conduuApp.referralForm', [])
  .component('referralForm', {
    template: require('./referral-form.component.html'),
    bindings: {
      dismiss: '&'
    },
    controller: referralFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/referral-form/referral-form.component.js